<template>
  <div class="radioktevent-box">
    <img class="radioktevent-banner1img" :src="imgurl" :alt="imgurl" />
    <!-- 요금제 알아보기 버튼 -->
    <button v-if="isshowktfooter" class="radioktevent-btn" @click="goMore">요금제 더 알아보기</button>
    <!-- 유의사항 -->
    <img
      v-if="isshowktfooter"
      class="radioktevent-banner1img"
      src="/media/images/landing/aplayz-banner2.jpg"
      alt="유의사항"
    />
  </div>
</template>
<script>
import { addClickCntEventPageApi } from '@/service/api/menuApi';

export default {
  props: {
    imgurl: {
      type: String,
      default: null,
      required: false
    },
    islogin: {
      type: Boolean,
      default: false,
      required: false
    },
    eventid: {
      type: String,
      default: null,
      required: false
    },
    channelfrom: {
      type: String,
      default: null,
      required: false
    },
    isshowktfooter: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    goMore() {
      this.onClickEventPage();
      window.open(`https://m.shop.kt.com:444/m/direct/directUsim/PartnerList.do?channel=aplayz`, '_blank');
    },
    onClickEventPage() {
      if (this.islogin) {
        addClickCntEventPageApi(this.$cookies.get('userId'), this.eventid, this.channelfrom);
      }
    }
  }
};
</script>
<style scoped src="@/assets/css/radiokteventbox/radiokteventbox.css"></style>
